import React from "react"
import IdleTimer from 'react-idle-timer'
import { latest as API_URL, login as API_LOGIN } from "./config/api";
import { current_year, past_year, getMonthFormat, getDayFormat, getDefaultValuesGeneral } from "./config/Helpers";
import axios from "axios";
//Login
import Login from "./Login";
//Componentes
import Header from "./components/Header";
import Alerts from "./components/Alerts";
import ReportModel from "./reports/ReportModel";
import FiltersTime from "./components/FiltersTime";
import FiltersActive from "./components/FiltersActive";
import SidebarLeft from "./components/SidebarLeft";

//Layouts
import LayoutReview from "./modules/marketing/review/Layout.js";
import LayoutReservation from "./modules/marketing/reservations/Layout.js";
import LayoutLeadTime from "./modules/marketing/lead-time/Layout.js";
import LayoutOccupancy from "./modules/marketing/occupancy/Layout.js";

//Sidebar Reviews
import SidebarReviewLeadTime from "./modules/marketing/lead-time/widgets/SidebarReview.js";
import SidebarReviewReservations from "./modules/marketing/reservations/widgets/SidebarReview.js";
import SidebarReviewOccupancy from "./modules/marketing/occupancy/widgets/SidebarReview.js";

const postUrlLogin        = API_LOGIN;
const postUrlWidgets      = API_URL + "widgets";
const postUrlDimensions   = API_URL + "dimensions";

function SidebarReview(props){
  if(props.panel === "lead-time"){
    return <SidebarReviewLeadTime
      response_request={props.app.state.leadtime_response_request}
      setStateSidebarReview={props.app.setStateSidebarReview}
      setPeriodSidebarReview={props.app.setPeriodSidebarReview}
      sidebar_review={props.app.state.sidebar_review}
    />
  }else if(props.panel === "reservation"){
    return <SidebarReviewReservations
      response_request={props.app.state.reservation_response_request}
      setStateSidebarReview={props.app.setStateSidebarReview}
      setPeriodSidebarReview={props.app.setPeriodSidebarReview}
      sidebar_review={props.app.state.sidebar_review}
    />
  }else if(props.panel === "occupancy"){
    return <SidebarReviewOccupancy
      response_request={props.app.state.occupancy_response_request}
      setStateSidebarReview={props.app.setStateSidebarReview}
      sidebar_review={props.app.state.sidebar_review}
    />
  }else{
    return null;
  }
}


class App extends React.Component{
  
  constructor(props){
    super(props);
    this.state = {
      isVisible : "loading-wait",
      key_trimester : "",
      flash_summary_module : {
        interval_time_selected : '$month'
      },
      pickup_module : {
        interval_time_selected : '$month'
      },
      reservations_module : {
        interval_time_selected : '$month'
      },
      occupancy_module : {
        interval_time_selected_reserves : '$month',
        interval_time_selected_production : '$month'
      },
      period_filter : "current_year",
      skip_channels : {},
      review_response_request : {},
      reservation_response_request : {},
      leadtime_response_request : {},
      occupancy_response_request : {},
      current_filter : "default",
      current_filter_agency : {},
      current_filter_brand : {},
      current_filter_business : {},
      current_filter_channel : {},
      current_filter_market : {},
      current_filter_plan : {},
      current_filter_properties : {},
      current_filter_region : {},
      current_filter_reserve : {},
      current_filter_segment : {},
      current_filter_time : {},
      current_filter_type_room : {},
      current_filter_type_tariff : {},
      current_filter_days : {},
      current_filter_dates : {},
      current_filter_days_comp : {},
      current_filter_dates_comp : {},
      show_time_compare : false,
      custom_calendar_active : "inactive", //[Pruebas] Debe ser "inactive"
      custom_list_report : "inactive", //[Pruebas] Debe ser "inactive"
      alert_datepicker_error : "inactive",
      alert_demo_version : "inactive",
      alert_error_network : "inactive",
      alert_modal_report_list : "inactive",
      alert_modal_report_new : "inactive",
      status_reserve : [],
      hotels : [],
      segments : [],
      segments_reservation : [],
      filter_by_pace : 0,
      view_results: "month",//[Pruebas] Debe ser "month"
      type_date : "date_nights",
      current_year : current_year(),
      past_year : past_year(),
      base_year : current_year(),
      type_date_class : "",
      panel: "review", //[Pruebas] Debe ser review
      first_request : true,
      secondary_filter_bar : "inactive-secondary-bar",
      sidebar_review : {
        current_period : { 
          key : "1 - 30 NOCHES", value : "serie_30" 
        },
        status : "",
        show : "hide"
      },
      status_sidebar : "inactive-sidebar",
      is_login : true,
      loading_filters : "hide",
      pickup : 0,
      token_request : (Math.random().toString(36).substr(2)) + (Math.random().toString(36).substr(2)),
      max_book_date : "",
      video_show : "",
      main_request_token_cancel : null
    }
    this.idleTimer = null
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.verifyToken              = this.verifyToken.bind(this);
    this.setFiltersComponent      = this.setFiltersComponent.bind(this);
    this.activeCustomCalendar     = this.activeCustomCalendar.bind(this);
    this.alertState               = this.alertState.bind(this);
    this.reportModelState         = this.reportModelState.bind(this);
    this.mainRequest              = this.mainRequest.bind(this);
    this.setFilterBubble          = this.setFilterBubble.bind(this);
    this.setViewList              = this.setViewList.bind(this);
    this.setTypeDateQuery         = this.setTypeDateQuery.bind(this);
    this.setCompareYear           = this.setCompareYear.bind(this);
    this.hideSelects              = this.hideSelects.bind(this);
    this.setFilterDays            = this.setFilterDays.bind(this)
    this.setTypePanel             = this.setTypePanel.bind(this)
    this.mainClick                = this.mainClick.bind(this)
    this.emptySegments            = this.emptySegments.bind(this)
    this.defaultValuesRequest     = this.defaultValuesRequest.bind(this)
    this.getInitialStatics        = this.getInitialStatics.bind(this)
    this.skipFilterChannel        = this.skipFilterChannel.bind(this);
    this.setStateSidebarReview    = this.setStateSidebarReview.bind(this);
    this.setPeriodSidebarReview   = this.setPeriodSidebarReview.bind(this)
    this.activeSecondaryBar       = this.activeSecondaryBar.bind(this)
    this.activeSidebar            = this.activeSidebar.bind(this)
    this.setSession               = this.setSession.bind(this)
    this.currentFilters           = this.currentFilters.bind(this)
    this.handleClickFilterPace    = this.handleClickFilterPace.bind(this);
  }

  componentDidMount(){
   /* var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/5bb23af4b033e9743d01edd6/default';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
        })();
            */
    this.verifyToken();

    let self = this;
    var qs = require("qs");
    axios.post(postUrlDimensions, 
      qs.stringify({
        api_token   : localStorage.getItem("api_token"),
        type        : "property"
    })).then(function (response){ 
        self.setState({ 
          hotels   : response.data,
        }) 
    })
  }
  activeSecondaryBar(active){
    if (active === "active"){
      this.setState({
        secondary_filter_bar : "active-secondary-bar"
      })
    }else{
      this.setState({
        secondary_filter_bar : "inactive-secondary-bar"
      })
    }
  }
  activeSidebar(state){
    let custom_list_report;

    if(state === "active-sidebar is-report"){
      custom_list_report = "active"
    }else{
      custom_list_report = "inactive"
    }
    this.setState({
      status_sidebar : state,
      custom_list_report : custom_list_report
    })
  }
  setPeriodSidebarReview(current_period){
    this.setState(function(prev){
        return { 
          sidebar_review : {
            status : prev.sidebar_review.status,
            current_period : current_period,
            show : prev.sidebar_review.show
          } 
        }
    })
}
  setStateSidebarReview(){
      this.setState(function(prev){
          const status = prev.sidebar_review.status === "active-sidebar" ? "" : "active-sidebar";
          return { 
            sidebar_review : {
              status : status,
              current_period : prev.sidebar_review.current_period,
              show : prev.sidebar_review.show
            } 
          }
      })
  }
  mainClick(){
    this.hideSelects()
  }
  setTypePanel(type){
    let view_results, type_date;
    switch (type) {
      case "review":
        view_results = "month";
        type_date = "date_nights"
        this._widgetFiltersTime.setState({
          current_view_review  : { key : "Meses", value : "month" }
        })
        break;
      case "reservation":
        view_results = "room_night";
        type_date = "date_nights"
        this._widgetFiltersTime.setState({
          current_view_reservation   : { key : "Room night", value : "room_night" }
        })
      break;
      case "lead-time":
        view_results = "room_night";
        type_date = "book_date"
        this._widgetFiltersTime.setState({
          current_view_leadtime   : { key : "Room night", value : "room_night" }
        })
      break;
      case "occupancy":
        view_results = "room_night";
        type_date = "date_nights"
        this._widgetFiltersTime.setState({
          current_view_leadtime   : { key : "Room night", value : "room_night" }
        })
      break;
    }
    this.setState({
      panel : type,
      view_results : view_results,
      type_date: type_date,
      sidebar_review : {
        current_period : this.state.sidebar_review.current_period,
        status : "",
        show : "hide"
      }
    }, function(){
      if(this._LayoutReview.state.active_slide.key === "pickup" && this.state.panel === "review"){
        this._widgetFiltersTime.setRangeCustom("pickup")
      }else{
        this._widgetFiltersTime.setRangeCustom("current_year")
      }
    })
  }

  emptySegments(value){
    delete this.state.current_filter_segment[value];
  }

  defaultValuesRequest(){
    let self = this;
    if(self.state.panel === "review"){
      if(self._LayoutReview.state.active_slide.key === "pickup"){
        self.setState({
          pickup_module : {
            interval_time_selected : '$month',
          },
          show_time_compare : false,
          secondary_filter_bar : "inactive-secondary-bar",
        }, function(){
          self._LayoutReview.setDefaultValuesModule();
        })
      }else{
        self.setState({
          flash_summary_module : {
            interval_time_selected : '$month',
          }
        }, function(){
          self._LayoutReview.setDefaultValuesModule();
        })
      }
    }else if(self.state.panel === "reservation"){
      self.setState({
        reservations_module : {
          interval_time_selected : '$month',
        }
      }, function(){
        self._LayoutReservation.setDefaultValuesModule();
      })
    }else if(self.state.panel === "lead-time"){
      self._LayoutLeadTime.setDefaultValuesModule();
    }else if(self.state.panel === "occupancy"){
      self.setState({
        occupancy_module : {
          interval_time_selected_reserves : '$month',
          interval_time_selected_production : '$month',
        }
      }, function(){
        self._LayoutOccupancy.setDefaultValuesModule();
      })
    }
  }
  hideSelects(type = null){
    let cont_datepicker = "hide";
    //let custom_calendar_active  = "inactive";

    if(type === "calendar_widget"){
      cont_datepicker = "";
      this.activeCustomCalendar("")
    }else{
      if(this._widgetFiltersTime.state.cont_datepicker === ""){
        this._widgetFiltersTime.handleClickApply("hide-select")
      }
    }
    
    this._widgetHeader.setState({
      module_menu_show  : "hide-panel",
      panel_menu_show   : "hide-panel",
      hotel_menu_show   : "hide-panel"
    });
    this._widgetFiltersTime.setState({
      period_menu_show          : "hide-panel",
      views_menu_show           : "hide-panel",
      status_menu_show          : "hide-panel",
      days_menu_show            : "hide-panel",
      comp_menu_show            : "hide-panel",
      years_menu_show           : "hide-panel",
      dias_menu_show            : "hide-panel",
      compare_menu_show         : "hide-panel",
      past_menu_years_show      : "hide-panel",
      cont_datepicker           : cont_datepicker
    })
    this._LayoutReview.setState({
      select_type_chart_status : "hide-panel"
    })
  }
  setCompareYear(current_year, past_year){
    this.setState({
       current_year : current_year,
       past_year    : past_year
    });
  }
  activeCustomCalendar(state){
    if(state === 'hide'){
      this.setState({ 
        custom_calendar_active : "inactive",
        //secondary_filter_bar : "inactive-secondary-bar" 
      })
    }
    else if (state === 'apply') {
      this.setState({
        custom_calendar_active: "inactive",
        secondary_filter_bar  : "inactive-secondary-bar" 
      })
    }else{
      this.setState({ custom_calendar_active : "active-custom-calendar" });
    } 
  }

  setFilterDays(temp_days){
    let days_filter = Object.assign({}, temp_days);
    this.setState({
      current_filter_days : days_filter
    })
  }
  alertState(type){
    console.log('hola')
    this.setState(function(prev){
      if(type === "datepicker"){
        const alert_state = prev.alert_datepicker_error === "active" ? "inactive" : "active";
        return { alert_datepicker_error : alert_state }
      }else if(type == "demo_version"){
        const alert_state = prev.alert_demo_version === "active" ? "inactive" : "active";
        return { alert_demo_version : alert_state }
      }else if(type == "error_network"){
        const alert_state = prev.alert_error_network === "active" ? "inactive" : "active";
        return { alert_error_network : alert_state }
      }
    })
  }
  reportModelState(type) {
    let self = this; 
    if (type === "models") {
      self.setState(function (prev) {
        const alert_state = prev.alert_modal_model_list === "active" ? "inactive" : "active";
        return { alert_modal_model_list: alert_state }
      })
    }else if (type === "reports") {
      self.setState(function (prev) {
        const alert_state = prev.alert_modal_report_list === "active" ? "inactive" : "active";
        return { alert_modal_report_list: alert_state }
      })
    }else if (type === "models-new") {
      self.setState(function (prev) {
        const alert_state = prev.alert_modal_model_new === "active" ? "inactive" : "active";
        return { alert_modal_model_new: alert_state }
      })
    }else if (type === "reports-new") {
      self.setState(function (prev) {
        const alert_state = prev.alert_modal_report_new === "active" ? "inactive" : "active";
        return { alert_modal_report_new: alert_state }
      })
    }
  }
  
  setViewList(view){
    let self = this;

    this.setState({
      view_results  : view,
      segments      : [],
      sidebar_review : {
        current_period : this.state.sidebar_review.current_period,
        status : "",
        show : "hide"
      }
    }, () => {
      self.defaultValuesRequest()
    })
  }
  setTypeDateQuery(type){
    this.setState({
      type_date : type,
      sidebar_review : {
        current_period : this.state.sidebar_review.current_period,
        status : "",
        show : "hide"
      }
    }, function(){
      this.mainRequest();
    })
  }

  handleClickFilterPace(){
    let self = this;
    this.setState( { filter_by_pace : self.state.filter_by_pace === 0 ? 1 : 0 })
  }

  currentFilters(extra_filter = null){
    const self = this;
    let filters = {
      api_token: localStorage.getItem("api_token"),
      current_filter: self.state.current_filter,
      current_filter_agency: self.state.current_filter_agency,
      current_filter_brand: self.state.current_filter_brand,
      current_filter_business: self.state.current_filter_business,
      current_filter_channel: self.state.current_filter_channel,
      current_filter_market: self.state.current_filter_market,
      current_filter_plan: self.state.current_filter_plan,
      current_filter_properties: self.state.current_filter_properties,
      current_filter_region: self.state.current_filter_region,
      current_filter_reserve: self.state.current_filter_reserve,
      current_filter_segment: self.state.current_filter_segment,
      current_filter_time: self.state.current_filter_time,
      current_filter_type_room: self.state.current_filter_type_room,
      current_filter_type_tariff: self.state.current_filter_type_tariff,
      current_filter_days: self.state.current_filter_days,
      current_filter_dates: self.state.current_filter_dates,
      current_filter_days_comp: self.state.current_filter_days_comp,
      current_filter_dates_comp: self.state.current_filter_dates_comp,
      segments : self._LayoutReview.state.filters_segment,
      segments_reservation : self._LayoutReservation._Reserves.state.filters_segment,
      skip_channels: self.state.skip_channels,
      key_trimester: self._LayoutReview.state.key_trimester,
      segments_active: self.state.segments_active,
      status_reserve: self.state.status_reserve,
      view_results: self.state.view_results,
      filter_by_pace : self.state.filter_by_pace,
      flash_summary_module : self.state.flash_summary_module,
      reservations_module : self.state.reservations_module,
      occupancy_module : self.state.occupancy_module,
      pickup : self.state.pickup,
      key_time: [
        self._LayoutReview.state.key_time,
        self.state.view_results
      ],
      key_time_reservation : self._LayoutReservation._Reserves.state.key_time,
      type_date: self.state.type_date,
      panel: self.state.panel
    }
    if(extra_filter !== null){
      filters = Object.assign({}, filters, extra_filter);
    }
    return filters;
  }
  mainRequest(params = {}, to_deploy_columns = false) {
    if(Object.keys(params).length > 0){
      if(params.flash_summary_module !== null){
        this.state.flash_summary_module = params.flash_summary_module;
      }
      if(params.reservations_module !== null){
        this.state.reservations_module = params.reservations_module;
      }
      if(params.occupancy_module !== null){
        this.state.occupancy_module = params.occupancy_module;
      }
    }
    let self = this;
    let token_request = (Math.random().toString(36).substr(2)) + (Math.random().toString(36).substr(2));
    this.state.token_request = token_request;

    /*const CancelToken = axios.CancelToken;
    let request_cancel = CancelToken.source();
    let self = this;

    if (self.state.request_cancel === null){
      self.setState({
        request_cancel : request_cancel
      });
    }else{
      self.state.request_cancel.cancel('Operation canceled by the user.');
      self.setState({
        request_cancel : request_cancel
      });
    }
    setTimeout(() => {
      axios.get(postUrlWidgets, {
        cancelToken: self.state.request_cancel.token
      }).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          console.log(thrown);
        }
      }); 
    }, 1000);*/
    var CancelToken = axios.CancelToken;
    var cancel;

    self._widgetHeader.setState({
      request_status: ""
    })

    self._widgetFiltersTime.setState({
      request_status: ""
    })

    self._LayoutReview.setState({
      request_status: ""
    })

    self._LayoutReservation.setState({
      request_status: ""
    })

    self._LayoutLeadTime.setState({
      request_status: ""
    })

    self._LayoutOccupancy.setState({
      request_status: ""
    })

    var qs = require("qs");

    if(self.state.main_request_token_cancel !== null){
      self.state.main_request_token_cancel();
    }
    setTimeout(() => {
      if(to_deploy_columns === false){
        self._widgetSidebar.getFilters();
      }
    }, 1000);

    axios({
      method : "POST",
      headers: { 'content-type' : 'application/x-www-form-urlencoded' },
      url : postUrlWidgets, 
      data : qs.stringify(self.currentFilters({token_request : token_request})),
      cancelToken : new CancelToken(function executor(c) {
        self.state.main_request_token_cancel = c;
      })
    }).then(function (response) {
      if(self.state.first_request === true){
        self.setState({
          isVisible: "",
          loading_filters : "hide"
        });
        setTimeout(() => {
          self.setState({
            isVisible: "loading-success",
            first_request : false
          })
        }, 1000);
      }
      self._widgetHeader.state.request_status = "hide";
      self._widgetFiltersTime.state.request_status = "hide";
      switch (self.state.panel) {
        case "review":
          self.setState(function(prev){ 
            return {
              review_response_request : response.data,
              loading_filters : "hide"
            }
  
          }, function(){
            if (response.data.token_request === this.state.token_request){
              self._LayoutReview.setState({
                request_status: "hide"
              })
              self._LayoutReview._widgetSegment.setState({
                load_complete: " "
              }, function(){

                self.setState(function(prev){
                  return {
                    sidebar_review : {
                      status : "",
                      current_period : prev.sidebar_review.current_period,
                      show : ""
                    }
                  }
                })
              })
            }
          })
        break;
        case "reservation":
          self.setState(function(prev){ 
            return {
              reservation_response_request : response.data,
              loading_filters : "hide"
            }
  
          }, function(){
            if (response.data.token_request === this.state.token_request) {
              self._LayoutReservation.setState({
                request_status: "hide"
              }, function(){
                self.setState(function(prev){
                  return {
                    sidebar_review : {
                      status : "",
                      current_period : prev.sidebar_review.current_period,
                      show : ""
                    }
                  }
                })
              })
            }
          })
        break;
        case "lead-time":
          self.setState(function(prev){
            return {
              leadtime_response_request : response.data,
              loading_filters : "hide"
            } 
          }, function(){
            if (response.data.token_request === this.state.token_request) {
              self._LayoutLeadTime.setState({
                request_status: "hide"
              }, function(){
                self.setState(function(prev){
                  return {
                    sidebar_review : {
                      status : "",
                      current_period : prev.sidebar_review.current_period,
                      show : ""
                    }
                  }
                })
              })
            }
          })
        break;
        case "occupancy":
          self.setState(function (prev) {
            return {
              occupancy_response_request: response.data,
              loading_filters : "hide"
            }
          }, function(){
            if (response.data.token_request === this.state.token_request) {
              self._LayoutOccupancy.setState({
                request_status: "hide"
              }, function(){
                self.setState(function(prev){
                  return {
                    sidebar_review : {
                      status : "",
                      current_period : prev.sidebar_review.current_period,
                      show : ""
                    }
                  }
                })
              })
            }
          })
        break;
      }
    }).catch(function(err){
      if(axios.isCancel(err)){
        console.log('im canceled');
      }
      else{
        console.log('error request');
        self.alertState('error_network')
      }
    });
  } 
  setFilterBubble(text, value, status, type, group = false,  current_filter_days = {}, years_compare = null){
    let self           = this;
    let array_elements  = [];
    if(type === "property"){
      array_elements          = this.state.current_filter_properties;
      if(typeof(value) === "object"){
        if(Object.keys(value).length > 0 ){
          array_elements = value
        }else{
          array_elements = {}
        }
      }else{
        array_elements[value]   = { "hotel" : text, "value" : value }
      } 
      self.setState({
        current_filter_properties : array_elements,
        current_filter_region     : [],
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())

    }else if (type === "time"){
      self.state.current_filter_time = [];
      array_elements  = self.state.current_filter_time;
      let start       = new Date(value[0]);
      let end         = new Date(value[1]);
      let start_now   = new Date(current_year(),0,1);
      let end_now     = new Date(current_year(),11,31);
      let start_comp  = value[2] !== undefined ? new Date(value[2]) : undefined;
      let end_comp    = value[3] !== undefined ? new Date(value[3]) : undefined;
      if(self._widgetFiltersTime !== null){
        if(self._widgetFiltersTime.state.datepicker_compare === "hide"){
          start_comp = new Date(value[0])
          start_comp.setFullYear(self._widgetFiltersTime.state.past_year_active);
          
          end_comp = new Date(value[1])
          end_comp.setFullYear(self._widgetFiltersTime.state.past_year_active);
        }
      }
        

      const start_str         = getDayFormat(start.getDate()) + "/" + getMonthFormat(start.getMonth() + 1) +  "/" + start.getFullYear();
      const end_str           = getDayFormat(end.getDate()) + "/" + getMonthFormat(end.getMonth() + 1) +  "/" + end.getFullYear();
      const start_now_str     = getDayFormat(start_now.getDate()) + "/" + getMonthFormat(start_now.getMonth() + 1) +  "/" + start_now.getFullYear();
      const end_now_str       = getDayFormat(end_now.getDate()) + "/" + getMonthFormat(end_now.getMonth() + 1) +  "/" + end_now.getFullYear();
      const start_str_comp    = getDayFormat(start_comp.getDate()) + "/" + getMonthFormat(start_comp.getMonth() + 1) +  "/" + start_comp.getFullYear();
      const end_str_comp      = getDayFormat(end_comp.getDate()) + "/" + getMonthFormat(end_comp.getMonth() + 1) +  "/" + end_comp.getFullYear();
      if(this.state.panel === "lead-time"){
        array_elements[value[0]]    = { "time" : start_str +  " - " + end_str, "value" : value[0] }

      }else{
        array_elements[value[0]]    = { "time" : start_str_comp +  " - " + end_str_comp + " vs. " + start_str +  " - " + end_str, "value" : value[0] }
      }

      this.setState({
        current_filter_time       : array_elements,
        current_filter_dates      : [start, end],
        current_filter_dates_comp : [start_comp, end_comp],
        current_filter            : "custom",
        show_time_compare         : (start_now_str === start_str && end_now_str === end_str) ? false : true,
        current_filter_days       : current_filter_days,
        current_year              : years_compare[0],
        past_year                 : years_compare[1],
        custom_calendar_active    : "inactive",
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "region"){
      array_elements          = this.state.current_filter_region;
      array_elements[value]   = { "region" : text, "value" : value }

      this.setState({
        current_filter_region     : array_elements,
        current_filter_properties : {},
        current_filter_brand      : {},
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }else if (type === "reserve"){
      
      array_elements          = this.state.current_filter_reserve;
      array_elements[value]   = { "reserve" : text, "value" : value }
      this.setState({
        current_filter_reserve     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }else if (type === "business"){
      
      array_elements          = this.state.current_filter_business;
      array_elements[value]   = { "business" : text, "value" : value }
      this.setState({
        current_filter_business     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "brand"){
      
      array_elements          = this.state.current_filter_brand;
      array_elements[value]   = { "brand" : text, "value" : value }
      this.setState({
        current_filter_brand        : array_elements,
        current_filter_properties   : {},
        current_filter_region       : {},
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "plan"){
      
      array_elements          = this.state.current_filter_plan;
      array_elements[value]   = { "plan" : text, "value" : value }
      this.setState({
        current_filter_plan     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, function(){
        this.mainRequest();
      })
    }
    else if (type === "segment"){
      
      array_elements          = this.state.current_filter_segment;
      array_elements[value]   = { "segment" : text, "value" : value }
      this.setState({
        current_filter_segment     : array_elements,
      })
    }
    else if (type === "type_room"){
      
      array_elements          = this.state.current_filter_type_room
      array_elements[value]   = { "type_room" : text, "value" : value }
      this.setState({
        current_filter_type_room     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "type_tariff"){
      
      array_elements          = this.state.current_filter_type_tariff
      array_elements[value]   = { "type_tariff" : text, "value" : value }
      this.setState({
        current_filter_type_tariff     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "channel"){
      if(group !== false){
        array_elements          = group;
      }else{
        array_elements          = this.state.current_filter_channel
        array_elements[value]   = { "channel" : text, "value" : value }
      }
      
      this.setState({
        current_filter_channel     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => {
        this._widgetSidebar.isCheckedSegment();
        this.defaultValuesRequest()
      })
    }
    else if (type === "agency"){
      
      array_elements          = this.state.current_filter_agency
      array_elements[value]   = { "agency" : text, "value" : value }
      this.setState({
        current_filter_agency     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "market"){
      
      array_elements          = this.state.current_filter_market
      array_elements[value]   = { "market" : text, "value" : value }
      this.setState({
        current_filter_market     : array_elements,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
  }
  skipFilterChannel(channels, type) {
    const current_channels = type === "default" ? {} : Object.assign({}, channels);
    this.setState({
      skip_channels: current_channels,
      sidebar_review : {
        current_period : this.state.sidebar_review.current_period,
        status : "",
        show : "hide"
      }
    }, () => this.mainRequest())
  }
  getInitialStatics(select_period, from_date, to_date, from_date_custom, to_date_custom, properties, status_reserve){

    let self     = this;
    let current_filter_dates, current_filter_dates_comp, current_filter;
    
    if(select_period === "custom"){
      current_filter  = "custom";
      current_filter_dates          = [ from_date, to_date ]
      current_filter_dates_comp     = [ from_date_custom, to_date_custom ]
    }
    else if(select_period === "default"){
      current_filter        = "default";
      current_filter_dates = [ "default", 0 ];
    }
    
    if(select_period === "reset"){
      let hotels                = self.state.hotels
      properties                = "all";
      current_filter            = "default";
      current_filter_dates     = ["default", 0];
      //self._widgetSidebar.setState(self._widgetSidebar.getDefaultValues())
      //self._widgetFiltersTime.setState(self._widgetFiltersTime.getDefaultValues('pickup'))
      let type_view, sidebar_review;

      switch (self.state.panel) {
        case "review":
          type_view = "month";
          sidebar_review = {
            current_period : { 
              key : "1 - 30 NOCHES", value : "serie_30" 
            },
            status : "",
            show : "hide"
          }
          break;
      
        case "lead-time":
          type_view = "room_night";
          sidebar_review = {
            current_period : { 
              key : "1 - 30 NOCHES", value : "serie_30" 
            },
            status : "",
            show : "hide"
          }
          break;

          case "reservation":
          type_view = "room_night";
          sidebar_review = {
            current_period : { 
              key : "1 - 30 NOCHES", value : "serie_30" 
            },
            status : "",
            show : "hide"
          }
          break;
          case "occupancy":
          type_view = "room_night";
          sidebar_review = {
            current_period : { 
              key : "1 - 30 NOCHES", value : "serie_30" 
            },
            status : "",
            show : "hide"
          }
          break;
      }

      self.setState({ 
        filters_channels              : [],
        segments                      : [],
        segments_reservation          : [],
        custom_calendar_active        : "inactive",
        view_results                  : type_view,
        filter_month_active           : "inactive",
        filter_segment_active         : "inactive",
        filter_trimester_active       : "inactive",
        key_time                      : null,
        key_time_reservation          : null,
        current_filter                : current_filter,
        current_filter_agency         : {},
        current_filter_brand          : {},
        current_filter_business       : {},
        current_filter_channel        : {},
        current_filter_market         : {},
        current_filter_plan           : {},
        current_filter_properties     : {},
        current_filter_region         : {},
        current_filter_reserve        : {},
        current_filter_segment        : {},
        current_filter_time           : {},
        current_filter_type_room      : {},
        current_filter_type_tariff    : {},
        current_filter_days           : {},
        current_filter_days_comp      : {},
        skip_channels                 : {},
        filter_by_pace                : 0,
        current_year                  : self.state.base_year,
        past_year                     : past_year(),
        sidebar_review                : sidebar_review,
        secondary_filter_bar          : "inactive-secondary-bar"
      },() => {
        if(self._LayoutReview.state.active_slide.key === "pickup" && self.state.panel === "review"){
          self._widgetFiltersTime.setRangeCustom("pickup", true)
        }else{
          self._widgetFiltersTime.setRangeCustom("current_year", true)
        }
      });

      Object.keys(hotels).map(function(key){
          hotels[key].status = "show";
      })
    }else if(select_period === "reset-dates"){
      //self._widgetSidebar.setState(self._widgetSidebar.getDefaultValues())
      //self._widgetFiltersTime.setState(self._widgetFiltersTime.getDefaultValues('pickup'))

      if(self._LayoutReview.state.active_slide.key === "pickup" && self.state.panel === "review"){
        self._widgetFiltersTime.setRangeCustom("pickup", true)
      }else{
        self._widgetFiltersTime.setRangeCustom("current_year", true)
      }
    }else if(select_period !== null){
      self.setState({
        current_filter            : current_filter, 
        current_filter_dates      : current_filter_dates,
        current_filter_dates_comp : current_filter_dates_comp,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, function(){
        if(self._LayoutReview.state.active_slide.key === "pickup" && self.state.panel === "review"){
          self._widgetFiltersTime.setRangeCustom("pickup")
        }else{
          self._widgetFiltersTime.setRangeCustom("current_year")
        }
      })
    }
    
    if(status_reserve !== null){
      self.setState({
        status_reserve : status_reserve
      }, function(){
        //this.mainRequest();
      })
    }
  }

  setFiltersComponent(type, elem, group = false){
    let array_filters,self = this;
    if(type === "property"){
      array_filters = this.state.current_filter_properties;
      delete array_filters[elem];
      Object.keys(self.state.hotels).map(function(key){
        if(self.state.hotels[key]._id === elem){
          self.state.hotels[key]["status"] = "show";
        }
      })
      this.setState({ 
        current_filter_properties : array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }else if (type === "time"){
      array_filters = this.state.current_filter_time;
      delete array_filters[elem];
      
      this._widgetFiltersTime.setState({
        current_period : { 
          key : "Año en curso", 
          value : "current_year" 
        }
      });

      this.setState({
        current_filter: "default", 
        current_filter_dates : [ "default", 0 ],
        current_filter_time : array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this._widgetFiltersTime.setRangeCustom("current_year"))
    }
    else if (type === "region"){
      array_filters = this.state.current_filter_region;
      delete array_filters[elem];
      this.setState({
        current_filter_region: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "reserve"){
      array_filters = this.state.current_filter_reserve;
      delete array_filters[elem];
      this.setState({
        current_filter_reserve: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "business"){
      array_filters = this.state.current_filter_business;
      delete array_filters[elem];
      this.setState({
        current_filter_business: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "brand"){
      array_filters = this.state.current_filter_brand;
      delete array_filters[elem];
      this.setState({
        current_filter_brand: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "plan"){
      array_filters = this.state.current_filter_plan;
      delete array_filters[elem];
      this.setState({
        current_filter_plan: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "segment"){
      array_filters = this.state.current_filter_segment;
      delete array_filters[elem];
      this.setState({
        current_filter_segment: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      })
    }
    else if (type === "type_room"){
      array_filters = this.state.current_filter_type_room;
      delete array_filters[elem];
      this.setState({
        current_filter_type_room: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "type_tariff"){
      array_filters = this.state.current_filter_type_tariff;
      delete array_filters[elem];
      this.setState({
        current_filter_type_tariff: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "channel"){
      if(group !== false){
        array_filters = group;
      }else{
        array_filters = this.state.current_filter_channel;
        delete array_filters[elem];
      }
      
      this.setState({
        current_filter_channel: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => {
        this._widgetSidebar.isCheckedSegment();
        this.defaultValuesRequest()
      })
    }
    else if (type === "agency"){
      array_filters = this.state.current_filter_agency;
      delete array_filters[elem];
      this.setState({
        current_filter_agency: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "market"){
      array_filters = this.state.current_filter_market;
      delete array_filters[elem];
      this.setState({
        current_filter_market: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
    else if (type === "day"){
      array_filters = this.state.current_filter_days;
      delete array_filters[elem];
      this.setState({
        current_filter_days: array_filters,
        sidebar_review : {
          current_period : this.state.sidebar_review.current_period,
          status : "",
          show : "hide"
        }
      }, () => this.defaultValuesRequest())
    }
  }
  setSession(state){
    let self = this;
    self.setState(function(prev){
    if(state === false){
      self._LayoutLeadTime.setDefaultValuesModule();
      self._LayoutOccupancy.setDefaultValuesModule();
      self._LayoutReview.setDefaultValuesModule();
      self._LayoutReservation.setDefaultValuesModule();
      return getDefaultValuesGeneral();
    }else{
        return {
          is_login : state,
        }
     }
      
    },function(){
      self.forceUpdate()
      if(state === true){
        var qs = require("qs");
        axios({
          method : "POST",
          headers: { 'content-type' : 'application/x-www-form-urlencoded' },
          url : postUrlDimensions, 
          data : qs.stringify({
              api_token : localStorage.getItem("api_token"),
              type : "property"
          }),
          /*cancelToken : new CancelToken(function executor(c) {
            self.state.main_request_token_cancel = c;
          })*/
        }).then(function (response) {
          self.setState({
            hotels: response.data,
          })
        }).catch(error => {
          console.log(error.response)
          self.alertState('error_network')
        });
        self.getInitialStatics("default");
      }
    })
  }
  verifyToken(){
    let self = this;
    if(self.state.isVisible === "loading-wait"){
      let data = {
        api_token : localStorage.getItem("api_token")
      };
      let qs = require("qs");
      axios.post(postUrlLogin, qs.stringify(data))
      .then(function (response) {
          if ( response.data["status"] === "error" ){
              localStorage.removeItem("api_token");
              localStorage.removeItem("name");
              localStorage.removeItem("email");
              self.setState({
                is_login : false,
                first_request : true
              }, function(){
                self.forceUpdate()
              })
          }else{
            self.setState({
              is_login : true,
              max_book_date : response.data["max_book_date"]
            })
            self.getInitialStatics("default");
          }
      })
      .catch(function (error) {
          console.log(error);
          self.alertState('error_network')
      });
    }
  }
  _onActive(e) {
    if (this.idleTimer.getRemainingTime() === 0){
      this.setState({
        video_show : "",
      })
    }
  }

  _onIdle(e) {
    let self = this;
    if (self.idleTimer.getRemainingTime() === 0){
      if(self.state.video_show !== ""){
        self.setState({
          flash_summary_module : {
            interval_time_selected : '$month'
          },
          pickup_module : {
            interval_time_selected : '$month'
          },
          reservations_module : {
            interval_time_selected : '$month'
          },
          occupancy_module : {
            interval_time_selected_reserves : '$month',
            interval_time_selected_production : '$month'
          },
          period_filter : "current_year",
          skip_channels : {},
          review_response_request : {},
          reservation_response_request : {},
          leadtime_response_request : {},
          occupancy_response_request : {},
          current_filter : "default",
          current_filter_agency : {},
          current_filter_brand : {},
          current_filter_business : {},
          current_filter_channel : {},
          current_filter_market : {},
          current_filter_plan : {},
          current_filter_properties : {},
          current_filter_region : {},
          current_filter_reserve : {},
          current_filter_segment : {},
          current_filter_time : {},
          current_filter_type_room : {},
          current_filter_type_tariff : {},
          current_filter_days : {},
          current_filter_dates : {},
          current_filter_days_comp : {},
          current_filter_dates_comp : {},
          show_time_compare : false,
          custom_calendar_active : "inactive", //[Pruebas] Debe ser "inactive"
          custom_list_report : "inactive", //[Pruebas] Debe ser "inactive"
          alert_datepicker_error : "inactive",
          alert_demo_version : "inactive",
          alert_error_network : "inactive",
          alert_modal_report_list : "inactive",
          alert_modal_report_new : "inactive",
          filter_by_pace : 0,
          view_results: "month",//[Pruebas] Debe ser "month"
          type_date : "date_nights",
          current_year : current_year(),
          past_year : past_year(),
          base_year : current_year(),
          type_date_class : "",
          panel: "review", //[Pruebas] Debe ser review
          secondary_filter_bar : "inactive-secondary-bar",
          sidebar_review : {
            current_period : { 
              key : "1 - 30 NOCHES", value : "serie_30" 
            },
            status : "",
            show : "hide"
          },
          status_sidebar : "inactive-sidebar",
          is_login : true,
          loading_filters : "hide",
          pickup : 0,
          token_request : (Math.random().toString(36).substr(2)) + (Math.random().toString(36).substr(2)),
          video_show : "",
          main_request_token_cancel : null
        }, function(){
          self._widgetHeader.setDefaultValues();
          self._widgetSidebar.setState(self._widgetSidebar.getResetValues());
          self._LayoutReservation.setState(self._LayoutReservation.getResetValues());
          self._LayoutLeadTime.setState(self._LayoutLeadTime.getResetValues());
          self._LayoutOccupancy.setState(self._LayoutOccupancy.getResetValues());
          self._widgetFiltersTime.setState(self._widgetFiltersTime.getResetValues());
          self._LayoutReview.setState(self._LayoutReview.getResetValues(),function(){
            setTimeout(() => {
              self.getInitialStatics("reset");
            }, 500);
          })  
          this._widgetVideo.play();
        })
      }
    }
  }
  render(){
    if(this.state.is_login){
      return(
        <div className="container-general">
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            timeout={120000}>
          </IdleTimer>
          <div className={"video-fixed " + this.state.video_show } >
           <video loop autoPlay controls="true" width='100%' ref={(child) => { this._widgetVideo = child; }}>
              <source src="http://api-beta.magnumleap.com/videos/present-2.mp4" type="video/mp4" />
            </video>
            <span className="btn-goto" onClick={() => {
              
              this._widgetVideo.pause();
              this.setState({
                video_show : "hide"
              })
            }}>
              EXPLORE LIVE DEMO
            </span>
            <span className="btn-goto-bottom"></span>
          </div>
          <div className={ "loading-general " + this.state.isVisible }>
            <span></span>
          </div>
          <div className={"loading-filters " + this.state.loading_filters} />
          <Header
            getInitialStatics={this.getInitialStatics}
            setFiltersComponent={this.setFiltersComponent}
            hotels={this.state.hotels}
            current_filter_properties={this.state.current_filter_properties}
            setFilterBubble={this.setFilterBubble}
            hideSelects={this.hideSelects}
            setTypePanel={this.setTypePanel}
            setSession={this.setSession}
            app={this}
            ref={(child) => { this._widgetHeader = child; }} 
          />
          <FiltersTime 
            app={this}
            ref={(child) => { this._widgetFiltersTime = child; }}
          />
          <main className="container-fluid main-container" onClick={this.mainClick}>
          <div className={"bkg-component custom-calendar " + this.state.custom_calendar_active}></div>
          <div className={"bkg-component list-report " + this.state.custom_list_report}></div>
            <SidebarLeft
              custom_calendar_active={this.state.custom_calendar_active}
              setFilterBubble={this.setFilterBubble}
              current_filter_properties={this.state.current_filter_properties}
              current_filter_time={this.state.current_filter_time}
              current_filter_region={this.state.current_filter_region}
              current_filter_reserve={this.state.current_filter_reserve}
              current_filter_business={this.state.current_filter_business}
              current_filter_brand={this.state.current_filter_brand}
              current_filter_plan={this.state.current_filter_plan}
              current_filter_segment={this.state.current_filter_segment}
              current_filter_type_room={this.state.current_filter_type_room}
              current_filter_type_tariff={this.state.current_filter_type_tariff}
              current_filter_channel={this.state.current_filter_channel}
              current_filter_market={this.state.current_filter_market}
              current_filter_agency={this.state.current_filter_agency}
              setFiltersComponent={this.setFiltersComponent}
              emptySegments={this.emptySegments}
              secondary_filter_bar={this.state.secondary_filter_bar}
              activeSidebar={this.activeSidebar}
              reportModelState={this.reportModelState}
              app={this}
              ref={(child) => { this._widgetSidebar = child; }} 
            />
            <SidebarReview 
              panel={this.state.panel}
              app={this}
            />
            <div className={"panels " + this.state.status_sidebar + " " + this.state.secondary_filter_bar} id="panels">
              <FiltersActive
                app={this}
                ref={(child) => { this._filtersActive = child; }} 
              />
              <div className={"review " + (this.state.panel !== "review" ? "hide-panel" : null) }>
                <div className="container-preview">
                  <LayoutReview
                    app={this}
                    ref={(LayoutReview) => { this._LayoutReview = LayoutReview; }}
                  />
                </div>
              </div>
              <div className={"reservations " + (this.state.panel !== "reservation" ? "hide-panel" : null) }>
                <div className="container-preview">
                  <LayoutReservation
                    app={this}
                    ref={(LayoutReservation) => { this._LayoutReservation= LayoutReservation; }}
                  />
                </div>
              </div>
              <div className={"lead-time " + (this.state.panel !== "lead-time" ? "hide-panel" : null)}>
                <div className="container-preview">
                  <LayoutLeadTime
                    app={this}
                    ref={(LayoutLeadTime) => { this._LayoutLeadTime = LayoutLeadTime; }}
                  />
                </div>
              </div>

              <div className={"occupancy " + (this.state.panel !== "occupancy" ? "hide-panel" : null)}>
                <div className="container-preview">
                  <LayoutOccupancy
                    app={this}
                    ref={(LayoutOccupancy) => { this._LayoutOccupancy = LayoutOccupancy; }}
                  />
                </div>
              </div>
            </div>
          </main>
          <Alerts
            alert_datepicker_error={this.state.alert_datepicker_error}
            alert_demo_version={this.state.alert_demo_version}
            alert_error_network={this.state.alert_error_network}
            alertState={this.alertState}
            app={this}
            ref={(Alerts) => { this._Alerts = Alerts; }}
          />
          <ReportModel
            alert_modal_model_list={this.state.alert_modal_model_list}
            alert_modal_report_list={this.state.alert_modal_report_list}
            alert_modal_model_new={this.state.alert_modal_model_new}
            alert_modal_report_new={this.state.alert_modal_report_new}
            reportModelState={this.reportModelState}
            ref={(child) => { this._ReportModel = child; }}
          />
        </div>
      )
    }else{
      return (
        <div>
          <Login 
            setSession={this.setSession}
          />
        </div>
      )
    }
  }
};
export default App


// WEBPACK FOOTER //
// ./src/Frontend/App.js